import React, { useState, useEffect } from "react";
import plus from "../../../src/assets/Images/plus.svg";
import { Breadcrumb, ConfigProvider, Select } from "antd";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import {
  DoubleRightOutlined,
  DeleteOutlined,
  EditOutlined,
  StopOutlined,
} from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  deleteShippingCost,
  getShippingCosts,
} from "../../../src/API  Functions/ShippingCostFunctions";
import { Link } from "react-router-dom";
import i18next from "i18next";
import {
  getPosSessionHistory,
  getPosSessionList,
} from "../../API  Functions/SessionHistoryFunctions";
import CloseSessionModal from "../../modals/CloseSession_Modal";
import { Drawer } from "antd";
import ShimmerLoader from "../../loading";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import { DatePicker } from "antd";
import LoadingSpinner from "../../components/Loading";
import arEG from "antd/lib/locale/ar_EG"; // Import Arabic locale
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { checkPermission } from "../../Utils/permissionHelper";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { Skeleton, Stack, Box, Grid } from "@mui/material";

const { RangePicker } = DatePicker;

const CashierSessionSkeleton = ({ count = 2 }) => {
  const cards = Array.from({ length: count });

  return (
    <>
      <div className="flex justify-center">
        <Skeleton variant="text" width={500} height={45} animation="wave" />
      </div>
      <div className="flex justify-center">
        <Skeleton variant="text" width={500} height={45} animation="wave" />
      </div>
      {cards.map((_, i) => (
        <div key={i} className="bg-[#F6F6F6] p-4 mb-4 rounded-lg">
          {/* Session Title */}
          <div className="flex justify-center">
            <Skeleton variant="text" width={200} height={32} animation="wave" />
          </div>

          {/* Rows */}
          <div className="grid grid-cols-1 gap-2 mt-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <div key={index} className="flex justify-between">
                <Skeleton
                  variant="text"
                  width={150}
                  height={22}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={90}
                  height={22}
                  animation="wave"
                />
              </div>
            ))}
          </div>

          {/* Print Button */}
          <div className="flex justify-end mt-4">
            <Skeleton
              variant="rectangular"
              width={140}
              height={36}
              animation="wave"
              sx={{ borderRadius: "6px" }}
            />
          </div>
        </div>
      ))}
    </>
  );
};

const SessionHistory = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  const userData = useSelector((state) => state?.login?.user?.result);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [showComponent, setShowComponent] = useState(false);
  const [storeuser, setstoreuser] = useState(null);

  const [popup, setpopup] = useState(false);
  const [blockdata, setblockdata] = useState([]);
  const [status, setstatus] = useState(1);
  const [successMessage, setSuccessMessage] = useState("");
  const [showCloseSessionModal, setShowCloseSessionModal] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);

  const [visible, setVisible] = useState(false);
  const [sessionHistoryData, setSessionHistoryData] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [selectedRange, setSelectedRange] = useState("current_week"); // New state to track selected range
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState("all");

  const [data, setData] = useState([]);
  const [actualData, setActualData] = useState([]);
  const { Option } = Select;
  const [selectedUser, setSelectedUser] = useState(null);
  const [retailerUserData, setRetailerUserData] = useState([]);
  const [searchSessionQuerry, setSearchSessionQuerry] = useState("");

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );

  const sessionOptions = [
    { value: "all", label: t("All Sessions") },
    { value: "opened", label: t("Opened") },
    { value: "closed", label: t("Closed") },
  ];

  const showDrawer = (historyData) => {
    setDrawerData(historyData);
    setVisible(true);
    setHistoryLoading(true);
    getSessionHistory(historyData.user_id, null, null, selectedRange, "");
    setSelectedUserId(historyData.user_id);
  };
  console.log("sessionHistoryData==>", sessionHistoryData);

  const getSessionHistory = (
    userId,
    startDate = null,
    endDate = null,
    filterType,
    text,
  ) => {
    const payload = {
      user_id: userId,
      search: text,
      limit: 30,
      offset: 0,
      filter_type: filterType,
      custom_start_date: startDate, // Optional for custom range
      custom_end_date: endDate, // Optional for custom range
      // lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    getPosSessionHistory(payload)
      .then((res) => {
        console.log(res?.result[0]?.message);
        setHistoryLoading(false);

        if (res?.result[0]?.message == "No data found for the given filters.") {
          setLoading(false);
          setSessionHistoryData([]);
        } else if (res?.result?.length > 0) {
          setSessionHistoryData(res.result);
          setLoading(false);
        } else {
          console.error("No session history found");
        }
      })
      .catch((error) => {
        console.error("Error fetching session history:", error);
      });
  };
  const onClose = () => {
    setVisible(false);
    setSessionHistoryData([]);
    setSelectedRange("current_week");
    setSearchSessionQuerry("");
  };

  // const getSessionList = () => {
  //   setLoading(true);
  //   getPosSessionList(user_id, company_id)
  //     .then((res) => {
  //       // console.log("SSSSSSSSS", res);

  //       if (res?.result.length > 0) {
  //         const AllList = res.result;

  //         if (AllList) {
  //           setData(AllList);
  //           setLoading(false);
  //         } else {
  //           console.error("No users found in the response.");
  //           setLoading(false);
  //         }
  //       } else {
  //         console.error("Response was not successful:", res);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching store users:", error);
  //       setLoading(false);
  //     });
  // };

  const getSessionList = () => {
    setLoading(true);
    // const userToSend = passedUserId ?? ""; // Use selected or logged-in user ID

    getPosSessionList(user_id)
      .then((res) => {
        if (res?.result?.length > 0) {
          if (selectedPaymentTerm === "all") {
            setData(res.result);
          } else {
            const filtered = res.result.filter(
              (item) =>
                item.last_sessions[0]?.session_state === selectedPaymentTerm,
            );
            setData(filtered);
          }
          // setData(res.result);
          setActualData(res.result);
        } else {
          console.error("No session list found");
          setData([]);
          setActualData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching store users:", error);
        setLoading(false);
      });
  };

  // console.log("DATAAA A", data);

  useEffect(() => {
    getSessionList();
    // GetUserData();
  }, []);

  // const GetUserData = async () => {
  //   try {
  //     const res1 = await getStoreUsers(user_id);

  //     if (res1?.result[0]?.status_code === 200) {
  //       const activeUsers = res1.result[0]?.response?.filter((user) =>
  //         // user.active === true &&
  //         user.user_id &&
  //         user.user_type !== "online_sale"
  //       );
  //       setRetailerUserData(activeUsers);
  //     } else {
  //       setRetailerUserData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching KPI data:", error);
  //     setLoading(false);
  //   }
  // };

  // const handleOptionChange = (selectedValue) => {
  //   setLoading(true);
  //   if (selectedValue === "All Users") {
  //     setSelectedUser(null);
  //     getSessionList(null); // Show all users
  //   } else {
  //     setSelectedUser(selectedValue);
  //     getSessionList(selectedValue); // Filter by user ID
  //   }
  // };

  const handleCloseSessionClick = (sessionId, accessToken) => {
    // console.log("LLLLLLL", sessionId);

    setSelectedSessionId(sessionId);
    setSelectedToken(accessToken);
    setShowCloseSessionModal(true);
  };
  // console.log("showCloseSessionModal", showCloseSessionModal);

  const handleDateRangeChange = (range) => {
    let CurrentSelection = range.target.value;

    const currentDate = new Date(); // Use native Date
    let startDate, endDate;

    if (CurrentSelection === "current_week") {
      setSelectedRange("current_week");
    } else if (CurrentSelection === "last_week") {
      setSelectedRange("last_week");
    } else if (CurrentSelection === "custom_range") {
      setSelectedRange("custom_range");
    }
    setSearchSessionQuerry("");
    setHistoryLoading(true);
    getSessionHistory(selectedUserId, startDate, endDate, CurrentSelection, "");
  };

  const handleCloseModal = () => {
    setShowCloseSessionModal(false);
    getSessionList();
  };

  const handleRangePickerChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      const startDate = dateStrings[0];
      const endDate = dateStrings[1];

      setSelectedRange("custom_range"); // Set custom range
      setSearchSessionQuerry("");
      setHistoryLoading(true);
      getSessionHistory(selectedUserId, startDate, endDate, selectedRange, ""); // Call API with custom range
    }
  };

  function HTMLData(session, t) {
    return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Session Report</title>
  <style>
    body {
      font-family: sans-serif;
      padding: 20px;
      background-color: #F6F6F6;
    }
    .session-box {
      background: #F6F6F6;
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 8px;
    }
    .session-title {
      font-size: 1.25rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 16px;
    }
    .grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 8px;
    }
    .row {
      display: flex;
      justify-content: space-between;
      font-size: 0.875rem;
    }
    .label {
      font-weight: 400;
    }
    .label-bold {
      font-weight: 600;
    }
  </style>
</head>
<body>
  <div class="session-box">
  <div class="session-title">${userData.company_name}</div>
    <div class="session-title">${session.session_name}</div>
    <div class="grid">
      <div class="row">
        <span class="label">${t("Opening Date")}</span>
        <span>${session.opening_date || "--"}</span>
      </div>
      <div class="row">
        <span class="label">${t("Closing Date")}</span>
        <span>${session.closing_date || "--"}</span>
      </div>
      <div class="row">
        <span class="label">${t("Status")}</span>
        <span>${session.status || "--"}</span>
      </div>
      <div class="row">
        <span class="label">${t("Number of Orders")}</span>
        <span>${session.order_count || "0"}</span>
      </div>
      <div class="row">
        <span class="label">${t("Number of Refunded Orders")}</span>
        <span>${session.refunded_order || "0"}</span>
      </div>
      <div class="row">
        <span class="label-bold">${t("Total Sales")}</span>
        <span>EGP ${Number(session.total_sales || 0).toFixed(2)}</span>
      </div>
      <div class="row">
        <span class="label">${t("Refunded Amount")}</span>
        <span>EGP ${Number(session.refunded_amt || 0).toFixed(2)}</span>
      </div>

      ${Object.keys(session.all_collection)
        .map((paymentMethod) => {
          const amount = Number(
            session.all_collection[paymentMethod] || 0,
          ).toFixed(2);
          return `
      <div class="row">
        <span class="label">${t(paymentMethod)} ${t("Collection")}</span>
        <span>EGP ${amount}</span>
      </div>
    `;
        })
        .join("")}

      <div class="row">
        <span class="label-bold">${t("Opening Cash")}</span>
        <span>EGP ${Number(session.opening_cash || 0).toFixed(2)}</span>
      </div>
      
      <div class="row">
        <span class="label">${t("Cash In")}</span>
        <span>EGP ${Number(session.cash_in || 0).toFixed(2)}</span>
      </div>
      <div class="row">
        <span class="label">${t("Cash Out")}</span>
        <span>EGP ${Number(session.cash_out || 0).toFixed(2)}</span>
      </div>
      <div class="row">
        <span class="label-bold">${t("Available Amount")}</span>
        <span>EGP ${Number(session.cash_available || 0).toFixed(2)}</span>
      </div>
    </div>
  </div>
</body>
</html>
`;
  }

  const renderSessionBox = (session) => {
    const onPrint = () => {
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(HTMLData(session, t));
      doc.close();

      iframe.contentWindow.focus();
      setTimeout(() => {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }, 1000);
    };

    const collection = session.all_collection || {};

    return (
      <div
        key={session.session_id}
        className="bg-[#F6F6F6] p-4 mb-4 rounded-lg"
      >
        {/* <div className="text-lg justify-center text-center font-semibold">
          {session.session_name}
        </div> */}
        <div className="text-lg justify-center text-center font-semibold">
          {(session.session_name || "").replace("POS", t("Cashier"))}
        </div>

        <div className="grid grid-cols-1 gap-2 mt-2">
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Opening Date")}</p>
            <p className="text-sm">{session.opening_date || "--"}</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Closing Date")}</p>
            <p className="text-sm">{session.closing_date || "--"}</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Status")}</p>
            <p className="text-sm">
              {session.status ? t(session.status) : "--"}
            </p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Number of Orders")}</p>
            <p className="text-sm">{session.order_count || "0"}</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">
              {t("Number of Refunded Orders")}
            </p>
            <p className="text-sm">{session.refunded_order || "0"}</p>
          </div>
          {/* <div className="flex flex-row justify-between">
            <p className="font-semibold text-sm">{t("Total Sales")}</p>
            <p className="text-sm">{`EGP ${Number(session.total_sales || 0).toFixed(2)}`}</p>
          </div> */}
          <div className="flex flex-row justify-between items-center">
            <div className="flex items-center gap-1">
              <p className="font-semibold text-sm">{t("Total Sales")}</p>
              <Tooltip
                title={t("Total Sales = All Collection - Refunded Amount")}
                arrow
              >
                <InfoOutlinedIcon
                  fontSize="inherit"
                  className="text-gray-500 cursor-pointer w-4 h-4"
                />
              </Tooltip>
            </div>
            <p className="text-sm">{`EGP ${Number(
              session.total_sales || 0,
            ).toFixed(2)}`}</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Refunded Amount")}</p>
            <p className="text-sm">{`EGP ${Number(
              session.refunded_amt || 0,
            ).toFixed(2)}`}</p>
            {/* <p className="text-sm">{`EGP ${session.refunded_amt || "0"}`}</p> */}
          </div>
          {/* Dynamically render all payment method collections */}
          {Object.keys(collection).map((paymentMethod) => (
            <div key={paymentMethod} className="flex flex-row justify-between">
              <p className="font-normal text-sm">{`${t(paymentMethod)} ${t(
                "Collection",
              )}`}</p>
              {/* <p className="text-sm">{`EGP ${collection[paymentMethod].toFixed(2) || "0"}`}</p> */}
              <p className="text-sm">{`EGP ${
                isNaN(Number(collection[paymentMethod]))
                  ? "0.00"
                  : Number(collection[paymentMethod]).toFixed(2)
              }`}</p>
            </div>
          ))}
          <div className="flex flex-row justify-between">
            <p className="font-semibold text-sm">{t("Opening Cash")}</p>
            <p className="text-sm">{`EGP ${Number(
              session.opening_cash || 0,
            ).toFixed(2)}`}</p>
          </div>

          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Cash In")}</p>
            {/* <p className="text-sm">{`EGP ${session.cash_in.toFixed(2) || "0"}`}</p> */}
            <p className="text-sm">{`EGP ${Number(session.cash_in || 0).toFixed(
              2,
            )}`}</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="font-normal text-sm">{t("Cash Out")}</p>
            <p className="text-sm">{`EGP ${Number(
              session.cash_out || 0,
            ).toFixed(2)}`}</p>
            {/* <p className="text-sm">{`EGP ${session.cash_out.toFixed(2) || "0"}`}</p> */}
          </div>
          {/* Cash Out Summary */}
          {session.cash_out_summary?.length > 0 &&
            session.cash_out_summary.map((item, index) => (
              <div
                key={index}
                className="flex flex-row justify-between items-center"
                style={{ marginTop: "-6px", marginBottom: "-6px" }}
              >
                <div className="flex items-center gap-1">
                  <span className="text-gray-700 text-lg">•</span>
                  <p className="text-sm text-gray-700 italic">
                    {item.remark || t("Other")}
                  </p>
                </div>

                <p className="text-sm text-gray-700 italic ">
                  {`EGP ${Number(item.amount || 0).toFixed(2)}`}
                </p>
              </div>
            ))}
          {/* <div className="flex flex-row justify-between">
            <p className="font-semibold text-sm">{t("Available Cash")}</p>
            <p className="text-sm">{`EGP ${Number(session.cash_available || 0).toFixed(2)}`}</p>
          </div> */}
          <div className="flex flex-row justify-between items-center">
            <div className="flex items-center gap-1">
              <p className="font-semibold text-sm">{t("Available Amount")}</p>
              <Tooltip
                title={t(
                  "Available Amount = All Collection + Opening Cash + Cash In - Refunded Amount - Cash Out",
                )}
                arrow
              >
                <InfoOutlinedIcon
                  fontSize="inherit"
                  className="text-gray-500 cursor-pointer w-4 h-4"
                />
              </Tooltip>
            </div>
            <p className="text-sm">{`EGP ${Number(
              session.cash_available || 0,
            ).toFixed(2)}`}</p>
          </div>
        </div>
        <div className="flex justify-end">
          <div
            // onClick={onPrint}
            onClick={() => {
              if (checkPermission("/pos/sessionHistory", isGinne)) {
                onPrint();
              }
            }}
            className="rounded-md bg-primaryBlue text-white text-base font-medium w-36 mt-4 py-1 flex justify-center cursor-pointer"
          >
            {t("Print")}
          </div>
        </div>
      </div>
    );
  };

  const searchUser = (searchText) => {
    setSelectedPaymentTerm("all");
    if (!searchText || searchText.trim() === "") {
      setData(actualData); // reset when empty
      return;
    }

    const text = searchText.toLowerCase();

    const filteredUsers = data.filter((user) => {
      const name =
        typeof user?.user_name === "string" ? user.user_name.toLowerCase() : "";

      return name.includes(text);
    });

    setData(filteredUsers);
  };

  const handleSessionChange = (value) => {
    setSelectedPaymentTerm(value);

    if (value === "all") {
      setData(actualData);
    } else {
      const filtered = actualData.filter(
        (item) => item.last_sessions[0]?.session_state === value,
      );
      setData(filtered);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex w-full">
        <div className="flex min-h-[93vh] flex-1 flex-col bg-[#F6F7F9]">
          <Navbar heading="Session History" />
          <div className="mx-2 font-extrabold sm:mx-5">
            <div className="mt-4 flex w-full flex-col gap-2 sm:mt-5 md:w-1/2 md:flex-row md:items-end md:gap-x-3">
              <SearchBox
                searchResult={(values) => searchUser(values)}
                placeholder={t("Search Users")}
              />
              <div className="w-full md:w-1/3">
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select Session Status")}
                  className="mt-1 h-10 md:mt-2"
                  value={selectedPaymentTerm}
                  onChange={handleSessionChange}
                >
                  {sessionOptions.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {t(option.label)}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
            {/* <div className=" mt-4 -ms-3">
              <Select
                className="overflow-hidden mx-3"
                style={{
                  width: 300,
                  minWidth: 200,
                  height: 40,
                }}
                placeholder={t("Select User")}
                value={selectedUser || "All Users"} // Set default value to "All Categories"
                onChange={handleOptionChange} // Keep this as is
              >
                <Option value="All Users">{t("All Users")}</Option>{" "}
                {Object.values(retailerUserData)?.map((option) => {
                  const { user_id, name, phone, email } = option;
                  let displayText = name;

                  if (phone) {
                    displayText += ` (${phone})`;
                  } else if (email) {
                    displayText += ` (${email})`;
                  }

                  return (
                    <Option key={user_id} value={user_id}>
                      {displayText}
                    </Option>
                  );
                })}
              </Select>
            </div> */}
            <>
              <div className="flex justify-between items-center"></div>
              <div className="mb-4 mt-1 grid grid-cols-1 gap-x-8">
                {data.map((val, i) => (
                  <div
                    key={i}
                    className="mt-4 h-30 w-full rounded-xl bg-[#FFFFFF] pb-2 shadow-sm hover:shadow-lg"
                  >
                    {/* {console.log("val", val?.last_sessions)} */}
                    {/* Check if last_sessions exist */}
                    {val?.last_sessions?.length > 0 ? (
                      <div className="flex flex-col justify-between ms-4 me-4 mt-4 mb-2">
                        {allStores && (
                          <span className="font-semibold text-gray-500">
                            {val?.last_sessions[0]?.store_name}
                          </span>
                        )}
                        <div className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-2">
                          <span className="text-base font-semibold text-[#272728] sm:text-lg">
                            {/* <span className="font-semibold">
                              {val?.store_name}
                            </span> */}
                            {val.user_name} ({t("Sessions")}-{val.session_count}
                            , {t("Orders")}-{val.order_count})
                          </span>
                          <span
                            className={`font-medium text-sm justify-end ${
                              val?.last_sessions[0]?.session_state === "opened"
                                ? "text-yellow-500"
                                : val?.last_sessions[0]?.session_state ===
                                    "closed"
                                  ? "text-green-500"
                                  : "text-gray-500"
                            }`}
                          >
                            {t(
                              val?.last_sessions[0]?.session_state === "opened"
                                ? t("Opened")
                                : t("Closed"),
                            )}
                          </span>
                        </div>

                        {/* Boxes for displaying additional data */}
                        {val?.last_sessions[0]?.session_state === "opened" && (
                          <>
                            <div className="mx-1 mt-4 grid grid-cols-1 gap-3 sm:mx-4 sm:grid-cols-2 lg:grid-cols-3">
                              <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                                <p className="font-normal text-sm">
                                  {t("Opening Date")}
                                </p>
                                <p className="text-sm">
                                  {val.last_sessions[0]?.start_at || "N/A"}
                                </p>
                              </div>
                              <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                                <p className="font-normal text-sm">
                                  {t("Current Orders")}
                                </p>
                                <p className="text-sm">
                                  {val.last_sessions[0]?.order_count}
                                </p>
                              </div>
                              <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                                <p className="font-normal text-sm">
                                  {t("Current Sales")}
                                </p>
                                <p className="text-sm">
                                  EGP{" "}
                                  {val.last_sessions[0]?.total_sales || "0.00"}
                                </p>
                              </div>

                              {/* <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                                <p className="font-normal text-sm">
                                  {t("Last Session Orders")}
                                </p>
                                <p className="text-sm">
                                  {val.last_sessions[1]?.order_count || "0.00"}
                                </p>
                              </div>
                              <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                                <p className="font-normal text-sm">
                                  {t("Last Order Sales")}
                                </p>
                                <p className="text-sm">
                                  EGP{" "}
                                  {val.last_sessions[1]?.total_sales || "0.00"}
                                </p>
                              </div> */}
                            </div>
                          </>
                        )}

                        {/* Additional data for closed sessions */}
                        {val?.last_sessions[0]?.session_state === "closed" && (
                          <div className="mx-1 mt-4 grid grid-cols-1 gap-3 sm:mx-4 sm:grid-cols-2 lg:grid-cols-5">
                            <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                              <p className="font-normal text-sm">
                                {t("Last Closing Date")}
                              </p>
                              <p className="text-sm mt-1">
                                {val.last_sessions[0]?.stop_at || "N/A"}
                              </p>
                            </div>
                            <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                              <p className="font-normal text-sm">
                                {t("Last Closing Cash")}
                              </p>
                              <p className="text-sm mt-1">
                                EGP{" "}
                                {val.last_sessions[0]?.closing_balance ||
                                  "0.00"}
                              </p>
                            </div>
                            <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                              <p className="font-normal text-sm">
                                {t("Last Session Orders")}
                              </p>
                              <p className="text-sm mt-1">
                                {val.last_sessions[0]?.order_count || "0.00"}
                              </p>
                            </div>
                            <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                              <p className="font-normal text-sm">
                                {t("Last Session Sales")}
                              </p>
                              <p className="text-sm mt-1">
                                EGP{" "}
                                {val.last_sessions[0]?.total_sales || "0.00"}
                              </p>
                            </div>
                            <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                              <p className="font-normal text-sm">
                                {t("Last Session Profit")}
                              </p>
                              <p className="text-sm mt-1">
                                EGP{" "}
                                {val.last_sessions[0]?.session_profit || "0.00"}
                              </p>
                            </div>
                          </div>
                        )}

                        <div className="ms-1 me-1 mt-4 flex justify-end gap-2 sm:ms-4 sm:me-4 flex-row">
                          <button
                            onClick={() => showDrawer(val)}
                            className={`flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-primaryBlue bg-white text-sm font-semibold text-primaryBlue sm:w-32`}
                            type="submit"
                          >
                            <p className="">{t("History")}</p>
                          </button>
                          {val?.last_sessions[0]?.session_state ===
                            "opened" && (
                            <button
                              // onClick={() =>
                              //   handleCloseSessionClick(
                              //     val?.last_sessions[0]?.session_id,
                              //     val?.last_sessions[0]?.access_token
                              //   )
                              // }
                              onClick={() => {
                                if (
                                  checkPermission(
                                    "/pos/sessionHistory",
                                    isGinne,
                                  )
                                ) {
                                  handleCloseSessionClick(
                                    val?.last_sessions[0]?.session_id,
                                    val?.last_sessions[0]?.access_token,
                                  );
                                }
                              }}
                              className={`flex h-10 w-full items-center justify-center gap-2 rounded-lg border bg-primaryBlue text-sm font-semibold text-white sm:w-32`}
                              type="submit"
                            >
                              <p className="">{t("Close Session")}</p>
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      // If no last_sessions, display "No Session Data"
                      <div className="flex flex-col">
                        <div className="flex flex-row justify-start mt-4 ms-4 font-medium text-lg text-[#272728]">
                          <span className="font-semibold">
                            {val.user_name} (S-{val.session_count}, O-
                            {val.order_count})
                          </span>
                        </div>
                        <p className="mt-2 text-lg text-center text-primaryBlue">
                          {t("No Session Data")}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
            {/* )} */}
            {/* {popup && (
              <Blockuserpopup
                onClose={() => setpopup(false)}
                data={blockdata}
                status={status}
                successMessage={successMessage}
              />
            )} */}
            {/* <p className='ml-20 mt-20'>Yet to be integrated</p> */}
          </div>
        </div>
      </div>
      {showCloseSessionModal && (
        <CloseSessionModal
          // closeModal={() => setShowCloseSessionModal(false)}
          closeModal={handleCloseModal}
          sessionId={selectedSessionId}
          accessToken={selectedToken}
        />
      )}

      <Drawer
        // title={t("Session History")}
        title={`${drawerData?.user_name} (S-${drawerData?.session_count}, O-${drawerData?.order_count})`}
        placement="right"
        width={
          typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 500
        }
        onClose={onClose}
        visible={visible}
      >
        {/* Display the session history data */}
        {historyLoading ? (
          <>
            <CashierSessionSkeleton />
          </>
        ) : (
          <div>
            <div className="mb-4">
              <SelectBox
                value={t(selectedRange)}
                options={[
                  { value: "current_week", label: t("Current Week") },
                  { value: "last_week", label: t("Last Week") },
                  { value: "custom_range", label: t("Custom Range") },
                ]}
                onChange={handleDateRangeChange}
                placeholder={t("select_date_range")}
              />
              {/* RangePicker for custom date selection */}
              {selectedRange === "custom_range" && (
                <ConfigProvider
                  direction={i18n.language === "ar" ? "rtl" : "ltr"}
                >
                  <RangePicker
                    className="w-full mt-2 h-10 range-picker-placeholder"
                    style={{ minWidth: 220 }}
                    onChange={handleRangePickerChange}
                    placeholder={[t("Start Date"), t("End Date")]}
                    // onChange={handleRangePickerChange}
                    // locale={i18next.language === "ar" ? arEG : undefined}
                  />
                </ConfigProvider>
              )}
              <div className="mt-3 w-full">
                <SearchBox
                  value={searchSessionQuerry}
                  width={"100%"}
                  searchResult={(values) => {
                    setSearchSessionQuerry(values);
                    getSessionHistory(
                      selectedUserId,
                      null,
                      null,
                      selectedRange,
                      values,
                    );
                  }}
                  placeholder={t("Search Session")}
                />
              </div>
            </div>

            {sessionHistoryData.length > 0 ? (
              sessionHistoryData.map((session) => renderSessionBox(session))
            ) : (
              <p className=" text-center mt-5">
                {t("No session data available")}
              </p>
            )}
          </div>
        )}
      </Drawer>
    </>
  );
};

export default SessionHistory;
